import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';

const SEOHead = ({ 
  title = "San Diego Gaming - Esports Tournaments & Gaming Community",
  description = "Join San Diego's premier gaming community! Discover esports tournaments, gaming events, clubs, and connect with fellow gamers in San Diego.",
  keywords = "san diego gaming, esports tournaments, gaming events, san diego esports, gaming community",
  image = "https://sandiegogaming.com/logo.png",
  url = "https://sandiegogaming.com",
  type = "website"
}) => {
  useEffect(() => {
    // Update document title
    document.title = title;
  }, [title]);

  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{title}</title>
      <meta name="title" content={title} />
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      
      {/* Twitter */}
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:url" content={url} />
      <meta property="twitter:title" content={title} />
      <meta property="twitter:description" content={description} />
      <meta property="twitter:image" content={image} />
      
      {/* Canonical URL */}
      <link rel="canonical" href={url} />
    </Helmet>
  );
};

export default SEOHead;

